import 'core-js/stable';
import 'leaflet/dist/leaflet.css';
import React from 'react';
import { render } from 'react-dom';
import 'regenerator-runtime/runtime';
import { initHotreload } from '@eas/common-web';
import { App } from './app';

if (process.env.NODE_ENV === 'development') {
  initHotreload('ws://localhost:8099');
}

render(<App />, document.getElementById('root'));
